import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-grid-system";
import { SectionHeader } from "./../Blocks.js";
import Section from "./Section.js";

const Item = ({ q, a, ll, lu }, key) => {
  return (
    <div key={key} className="mb4">
      <h3 className="h5 color-navy mb2 font-regular line-height-4">{q}</h3>
      <p className="font-light color-bg line-height-5">
        {a}
        {ll && ll.length > 0 ? <a href={lu} target="_blank">{` ${ll}`}</a> : ""}
        .
      </p>
    </div>
  );
};

const SectionFAQ = (props, context) => {
  const copy = context.copy.get("SectionFAQ");

  var links = document.querySelectorAll(".section-faq a");

  for (var i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = "_blank";
    }
  }

  return (
    <Section id="FAQs" className="section-faq no-gutter pt3 pb4 pmt0">
      <Container className="">
        <Row>
          <Col className="pt1 mb3">
            <SectionHeader style={{ marginTop: 0 }}>
              {copy && copy.title}
            </SectionHeader>
          </Col>
        </Row>
        <Row>
          <Col md={6} offset={{ md: 3 }}>
            {copy ? copy.questions.map((d, i) => Item(d, i)) : false}
          </Col>
        </Row>
      </Container>
    </Section>
  );
};
SectionFAQ.contextTypes = { copy: PropTypes.object };

export default SectionFAQ;



// WEBPACK FOOTER //
// ./src/Home/SectionFAQ.js